import * as React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import DialogPopup, {
  DialogPopupProps,
  FooterButton,
} from '@wix/da-shared-react/pkg/Popup/Dialog';
import {
  BiEventType,
  BiUpdateType,
} from '@wix/da-shared-react/pkg/biLogger/constants';
import HeroPreview from './HeroPreview';

import * as s from './PositionManager.scss';

export type Props = Pick<DialogPopupProps, 'onClose'> & {
  onOpenMediaManager: () => void;
  onSubmit: (offsetY: number) => void;
};

export class PositionManager extends React.Component<
  Props & WithTranslation,
  { offsetY: number }
> {
  state = {
    offsetY: 0,
  };
  render() {
    const { t, onClose } = this.props;

    return (
      <DialogPopup
        isOpen
        title={t<string>('common.profileHero.adjustCoverPosition')}
        headerExtras={t('common.profileHero.adjustCoverPosition.subtitle')}
        footer={this.renderFooter()}
        onClose={onClose}
        rootClassName={s['root']}
        contentClassName={s['content-container']}
      >
        <div className={s['content-inner-container']}>
          <HeroPreview onChangeOffsetY={this.changeOffsetY} />
        </div>
      </DialogPopup>
    );
  }

  changeOffsetY = offsetY => {
    this.setState({ offsetY });
  };

  renderFooter = () => {
    const { onOpenMediaManager, t } = this.props;

    return (
      <>
        <FooterButton
          view="b2"
          type="button"
          onClick={onOpenMediaManager}
          biData={{
            evid: BiEventType.PROFILE_COVER_CLICK,
            version: 'eclipse',
            is_update: BiUpdateType.CHANGE,
          }}
        >
          {t!('common.profileHero.chooseAnotherImage')}
        </FooterButton>
        <FooterButton type="button" onClick={this.onSubmit}>
          {t!('common.done')}
        </FooterButton>
      </>
    );
  };

  onSubmit = () => {
    this.props.onSubmit(this.state.offsetY);
  };
}

export default withTranslation()(PositionManager);
